import { useEffect } from "react";
import { LogOut } from "lucide-react";

const leave = () => {
  window.open("https://www.google.com.au", "_newtab");
  window.location.replace("https://www.bom.gov.au");
};

export const QuickExit = () => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") leave(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <button
      data-testid="quick-exit-button"
      onClick={leave}
      title="Leave this site quickly (or press Esc)"
      className="fixed bottom-5 left-5 z-[60] flex items-center gap-2 rounded-full bg-ochre px-5 py-3 text-sm font-bold text-sand shadow-2xl ring-2 ring-sand/80 transition-transform duration-300 hover:scale-105 print:hidden"
    >
      <LogOut className="h-4 w-4" /> Quick exit
    </button>
  );
};
